import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AddSignatoryComponent } from "./add-signatory/add-signatory.component";
import { MembershipOwnerComponent } from "../membership-owner/membership-owner.component";
import { TranslateModule } from '@ngx-translate/core';
import { Utils } from '../../../../../Utils/utils';
import { ApiEndPoints, ApiRoot } from '../../../../../shared/constants/api-endpoints';
import { DocumentServiceType, FieldValue, ServiceName, SrActionType, SrIOName, UserType } from '../../../../../shared/constants/services.enum';
import { ApiService } from '../../../../../core/services/api.service';
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { AddSignatoryRequest, DCMemSRRelationship, ListOfDCMemSRRelationship } from '../../../../../shared/models/services-request/add-signatory.model';
import { SharedService } from '../../../../../shared/services/shared.service';
import { RoutesPath } from '../../../../../shared/constants/routes-path';
import { ActivatedRoute, Router } from '@angular/router';
import { CardCarouselComponent } from "../../../../../shared/components/card-carousel/card-carousel.component";
import { SrSubmitSuccessModalComponent } from "../../../../../shared/components/sr-submit-success-modal/sr-submit-success-modal.component";
import { FileComponent } from "../../../../../shared/components/controls/file/file.component";
import { ServiceProgressComponent } from "../../../../../shared/components/service-progress/service-progress.component";
import { ValidationMessageComponent } from "../../../../../shared/components/validation-message/validation-message.component";
import { SrStatus } from '../../../../../shared/constants/status.enum';
import { SkeletonLoaderComponent } from "../../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { AllowedDocumentType, FolderResponse } from '../../../../../shared/models/documents-response.model';
import { PendingSrModalComponent } from "../../../../../shared/components/pending-sr-modal/pending-sr-modal.component";
import { NotesComponent } from "../../../../../shared/components/notes/notes.component";
import { MembershipSharedService } from '../membership-shared-service';
import { LookupKey } from '../../../../../shared/constants/lookup-keys';
import { LookupService } from '../../../../../core/services/lookup.service';
import { DcMethodValues } from '../../../../../shared/constants/dc-method.constants';

@Component({
  selector: 'app-manage-signatories',
  imports: [AddSignatoryComponent, TranslateModule, ButtonComponent, CardCarouselComponent, SrSubmitSuccessModalComponent, FileComponent, ServiceProgressComponent, ValidationMessageComponent, SkeletonLoaderComponent, PendingSrModalComponent, NotesComponent],
  templateUrl: './manage-signatories.component.html',
  styleUrl: './manage-signatories.component.scss'
})
export class ManageSignatoriesComponent implements OnInit, OnDestroy {
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;
  request: AddSignatoryRequest = new AddSignatoryRequest();
  documentServiceType = DocumentServiceType;
  ownerList: any[] = [];
  addOwnerModal: boolean = false;
  signatoryModalEditable: boolean = false;
  selectedOwner: any;
  accountId: any = "";
  srNumber: any = "";
  userCSN: any = "";
  lang: string = "en";
  loadingSignatory: boolean = false;
  userType: string = "";
  srInprgoressAwating: boolean = false;
  showNotes: boolean = false;
  // This method is used to initialize the class instance using api, shared service, router, and route
  constructor(
    private api: ApiService,
    private sharedService: SharedService,
    private router: Router,
    private route: ActivatedRoute,
    private lookupService: LookupService
  ) {
    this.userType = this.sharedService.getPrimaryAccount()['Account Type Code'];
    this.lang = this.sharedService.getCurrentLang();
    this.accountId = this.sharedService.getCsnAccountId('id');
    this.userCSN = this.sharedService.getCsnAccountId('csn');
    this.loadingSignatory = true;
    this.getCountryLOV();
    this.setInitialValues();
  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    //this.getSRDetail();
  }

  memberships: any = [];
  membershipId: string = "";
  // This method is used to set initial values
  setInitialValues() {
    this.getActiveMembership();
    //only for Member
    if (this.userType != UserType.MEMBER) {
      this.sharedService.toastMessage('INFO', 'ONLY_MEMBER_ALLOWED', 'info', true);
      this.router.navigate([RoutesPath.DASHBOARD]);
      return
    }
    if (this.memberships.length < 1) {
      this.sharedService.toastMessage('INFO', 'NO_ACTIVE_MEMBERSHIP', 'info', true);
      this.router.navigate([RoutesPath.DASHBOARD]);
      return
    }
    if (!this.userCSN) {
      this.sharedService.toastMessage('INFO', 'SELECTED_MEMBERSHIP_INPROGRESS', 'info');
      this.router.navigate([RoutesPath.DASHBOARD]);
      return
    }

    // SR Number in the url
    this.sharedService.getSrNumber(this.route).subscribe(srNumber => {
      if (srNumber) {
        this.srNumber = srNumber;
        this.getSRDetail();
      }
    });

    // in case of draft
    if (sessionStorage.getItem("srNumber") && this.srNumber == "") {
      let storeSrNumber: any = sessionStorage.getItem("srNumber");
      this.srNumber = storeSrNumber;
      this.getSRDetail();
    }   
  }
  pendingSrNumber: string = "";
  pendingSrDetail: any = "";
  // This method is used to check for pending sr
  checkForPendingSr() {
    if (this.srNumber == "") {      
      this.sharedService.checkInprogressApplication(this.userCSN, ServiceName.MEMBERSHIP, ServiceName.MEMBERSHIP_MANAGEMENT_SIGNATORIES)
        .subscribe({
          // This method is used to handle the next callback using response
          next: (response: any) => {
            if (response["Error Code"] == null && response["Error Message"] == null && response?.SiebelMessage['DC Community Portal SR']) {
              const srData = response?.SiebelMessage['DC Community Portal SR'];
              const srRecords = Array.isArray(srData) ? srData : [srData];
              const pendingSrNumbers = srRecords
                .map((sr: any) => sr?.['SR Number'])
                .filter(Boolean);
              if (pendingSrNumbers.length) {
                this.pendingSrNumber = pendingSrNumbers.join(', ');
                this.pendingSrDetail = Array.isArray(srData) ? srRecords : srData;
                return;
              }
            } else {
              this.getMemberDetail();
            }
          }
        })
    }
  }

  // This method is used to get active membership
  getActiveMembership() {
    this.membershipId = this.userCSN;
    let userDetails: any = this.sharedService.getUserProfile();
    let accounts = Utils.checkIsArray(userDetails?.Account) ?? [];
    const filteredAccounts = accounts.filter((acc: any) => {
      // must have CSN
      if (!acc.CSN || acc.CSN.trim() === '') {
        return false;
      }
      // must not be inactive
      if (this.sharedService.isInactiveMemberAccount(acc)) {
        return false;
      }
      // use common method for membership expiry validation
      return Utils.isMembershipValid(acc["DC Expiry Date"]);
    });
    this.memberships = filteredAccounts;
  }
  memberDetail: any;
  memberLabelOwnerPartnerList: any = [];
  // This method is used to get member detail
  getMemberDetail() {
    if (!this.userCSN) {
      return;
    }
    this.memberLabelOwnerPartnerList = [];
    this.loadingSignatory = true;
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Member Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.MANAGE_SIGNATORIES,
        "IOName": "DC Get Acc Details IO",
        "CSN": this.userCSN
      }
    }
    this.api.post(ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_MEMBER_DETAIL_BY_CSN,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        this.loadingSignatory = false;
        if (response["Error Code"] == "" && response["Error Message"] == "" && response["SiebelMessage"]) {
          if (response["SiebelMessage"]['DC Account Data Transfer']) {
            this.memberDetail = response["SiebelMessage"]['DC Account Data Transfer'];
            this.licenseCategory = this.memberDetail["DC License Category"];
            this.openFolder();

            //If new sr then fill signatories

            if (this.memberDetail["Party Relationship To"]) {
              let signatories = Utils.checkIsArray(this.memberDetail["Party Relationship To"]);
              signatories?.map((p: any, index: number) => {
                if (p["Related Party Type"] != "Organization") {
                 
                  const ownerCountry = this.getMatchedCountryValue(p["DC Cust Nationality"]) || "";
                  let isAuthSignatory = p["DC Authorized Signatory"] ? p["DC Authorized Signatory"] : "N";
                  let passportExpDate = p["DC PP Exp Date"] ? new Date(p["DC PP Exp Date"]) : null; //p['DC PP Exp Date'] ? p['DC PP Exp Date'].split(' ')[0].split('/') : "";
                  let memberDob = p["Member DOB"] ? new Date(p["Member DOB"]) : null; // p["Member DOB"] ? p["Member DOB"].split(' ')[0].split('/') : "";
                  let object = {
                    ownerId: index + 1,
                    roles: "",
                    typeOfAddUser: 'New profile',
                    partnerType: p["Related Party Type"] == 'Organization' ? 'Company' : 'Individual', //p['DC Relationship Type'] == 'Organization' ? 'Company' : 'Individual',
                    isResident: p["UAE Citizen"] && (p["UAE Citizen"] == FieldValue.YES || p["UAE Citizen"] == FieldValue.YES_AR) ? 'Yes' : 'No',
                    emiratesId: p["DC Emirates ID Number"],
                    emiratesDob: {
                      day: memberDob ? memberDob.getDate().toString().padStart(2, '0') : null,
                      month: memberDob ? (memberDob.getMonth() + 1).toString().padStart(2, '0') : null,
                      year: memberDob ? memberDob.getFullYear() : null,
                    },
                    passportNumber: p["DC DED Partner Passport Number"], //p["DC DED Partner Passport Number"],
                    passportExpiry:
                    {
                      day: passportExpDate ? passportExpDate.getDate().toString().padStart(2, '0') : null,
                      month: passportExpDate ? (passportExpDate.getMonth() + 1).toString().padStart(2, '0') : null,
                      year: passportExpDate ? passportExpDate.getFullYear() : null,
                    },
                    nameEn: p["Related Party Contact Name Eng"] ?? "", //p["DC Contact Name(ENGLISH)"],
                    nameAr: p["Related Party Contact Name Ara"] ?? "", //p["DC Contact Name(ARABIC)"],
                    nationality: ownerCountry ? ownerCountry : null,
                    companyNameEn: p["DC Name(ENGLISH)"],
                    companyNameAr: p["DC Name(ARABIC)"],
                    share: p["DC Ownership Percent"],//p["DC Ownership Percent"],
                    mobile: p["DC Mobile Number"] ? Utils.parseMobile(p["DC Mobile Number"], 'number') : '',
                    countryCode: p["DC Mobile Number"] ? Utils.parseMobile(p["DC Mobile Number"], 'cc') : '',
                    email: p["DC Email Address"],
                    authorisedSignatory: isAuthSignatory,
                    relationType: p["Relationship Type"], //p["Relationship"],
                    endDate: p["End Date"],
                    action: "No Change",
                    isNewSignatory: false,
                    accountMembershipId: p["Row Id"] ? p["Row Id"] : ''
                  }
                  this.memberLabelOwnerPartnerList.push(object);
                  if (!this.srNumber) {
                    this.ownerList = [...this.ownerList, object];
                  }
                }
              });
              if (!this.srNumber) {
                this.submitSRData(SrActionType.DRAFT);
              }

            }
          }
        } else {
          this.sharedService.toastMessage("error", '', 'error', response["Error Message"]);
        }
      },
      error: () => {
        this.loadingSignatory = false;
      }
    })
  }
  //get folder id and attachments
  licenseCategory: string = "";
  srFolder!: FolderResponse;
  mainFromSectionDocs: AllowedDocumentType[] = [];
  memberDocuments: any[] = [];
  memberDocumentFolderId: string | null = null;
  shouldClearMoaFromMemberDocs: boolean = false;
  loadingDoc: boolean = false;
  private readonly noChangeSupportDocumentTypes = new Set<string>([
    'Memorandum_of_Association',
    'Authorization_Letter',
    'Letter_From_Authorized_Person',
    'Trade_License_Copy',
    'Support_Document',
    'Power_of_Attorney'
  ]);
  // This method is used to open folder
  openFolder() {
    this.loadingDoc = true;
    let isLabels = !this.srNumber; // true if srNumber is empty
    this.sharedService.getDocuments(this.srNumber, DocumentServiceType.MANAGE_SIG, isLabels, { licenseType: this.licenseCategory == FieldValue.FREE_ZONE ? DocumentServiceType.LIC_CATG_FZ : DocumentServiceType.LIC_CATG_NFZ })
      .subscribe({
        next: (response: any) => {
          this.loadingDoc = false;
          if (response.success) {
            // If SR exists → response.data, otherwise → response
            this.srFolder = response.data ? response.data : response;
            this.mainFromSectionDocs = this.srFolder.allowedDocumentTypes?.filter((d: any) => !d.forUISection);

            this.getMemberDocuments()
          } else {
            this.sharedService.toastMessage("error", response.message, 'error');
          }
        },
        error: err => {
          this.loadingDoc = false;
          this.sharedService.toastMessage("error", '', 'error', err);
        }
      });
  }
  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    // If there are no docs to check, nothing is missing
    if (!this.mainFromSectionDocs || this.mainFromSectionDocs.length === 0) {
      return false;
    }
    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];

    // ViewChildren not ready or not fully rendered yet – defer document checks
    if (fileCmps.length < this.mainFromSectionDocs.length) {
      return false;
    }

    let hasMissing = false;
    for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
      const doc = this.mainFromSectionDocs[index];
      const cmp = fileCmps[index];
      // Safety guard; should not happen due to length check above
      if (!cmp) continue;

      if (typeof cmp.checkMissing === 'function' && cmp.checkMissing((doc)?.mandatory)) {
        hasMissing = true;
      }
    }
    return hasMissing;
  }

  // This method is used to get sr detail
  getSRDetail() {
    this.loadingSignatory = true;
    const requestPayload = {
      "body": {
        "ProcessName": "DC Get SR Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.MANAGE_SIGNATORIES,
        "SR Number": this.srNumber,
        "IOName": SrIOName.MEMBERSHIP
      }
    };
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_SR_DETAIL,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response?.SiebelMessage) {
          this.loadingSignatory = false;
          const serviceRequest = response?.SiebelMessage["DC Mem SR"];
          this.accountId = serviceRequest['Account Id'];
          this.userCSN = serviceRequest['CSN'];

          if (this.srNumber) {
            this.getMemberDetail();
          }
          // Ownership details
          if (serviceRequest["DC Mem SR Relationship"]) {
            let membershipKey = serviceRequest["DC Mem SR Relationship"];
            const relationships = Utils.checkIsArray(membershipKey);

            relationships?.map((p: any, index: number) => {
              let relationshipKey = p["Relationship"];
              let jobTitle = p["DC Job Title"] ? p["DC Job Title"] : "Owner";
              let isAuthSignatory = p["DC Authorized Signatory"] ? p["DC Authorized Signatory"] : "N";

              //const role = this.getRolesFromRelationshipJobTitle(relationshipKey, jobTitle, isAuthSignatory);
              let passportExpDate = p['DC PP Exp Date'] ? p['DC PP Exp Date'].split('/') : "";
              let memberDob = p["Member DOB"] ? p["Member DOB"].split('/') : "";

              let object = {
                ownerId: index + 1,
                roles: "",
                typeOfAddUser: 'New profile',
                partnerType: p['DC Relationship Type'] == 'Organization' ? 'Company' : 'Individual',
                isResident: p['UAE Citizen'],
                emiratesId: p["DC Emirates ID Number"],
                emiratesDob: {
                  day: memberDob ? memberDob[1] : null,
                  month: memberDob ? memberDob[0] : null,
                  year: memberDob ? Number(memberDob[2].toString()) : null,
                },
                passportNumber: p["DC DED Partner Passport Number"],
                passportExpiry:
                {
                  day: passportExpDate ? passportExpDate[1] : null,
                  month: passportExpDate ? passportExpDate[0] : null,
                  year: passportExpDate ? Number(passportExpDate[2].toString()) : null,
                },
                nameEn: p["DC Contact Name(ENGLISH)"],
                nameAr: p["DC Contact Name(ARABIC)"],
                nationality: p["DC Contact Nationality"],
                companyNameEn: p["DC Name(ENGLISH)"],
                companyNameAr: p["DC Name(ARABIC)"],
                share: p["DC Ownership Percent"],
                mobile: p["DC Cell Phone"] ? Utils.parseMobile(p["DC Cell Phone"], 'number') : '',
                countryCode: p["DC Cell Phone"] ? Utils.parseMobile(p["DC Cell Phone"], 'cc') : '',
                email: p["DC Email Address"],
                authorisedSignatory: isAuthSignatory,
                relationType: p["Relationship"],
                endDate: p["DC End Date"],
                action: "",
                isNewSignatory: false,
                accountMembershipId: p["Row Id"] ? p["Row Id"] : ''
              }
              this.ownerList = [...this.ownerList, object];
            })

            this.step = 2;
          }
          if (this.sharedService.enableNotesOption(serviceRequest["Status"])) {
            this.srInprgoressAwating = true;
            this.showNotes = true;
          }
          this.currentSrStatus = serviceRequest["Status"] || '';

          if (serviceRequest["Status"] != SrStatus.Draft && serviceRequest["Status"] != SrStatus.AwaitingClarification && serviceRequest["Status"] != SrStatus.Open) {
            this.showActions = false;
          }
        }
      },
      error: () => {
      }
    });
  }
  // This method is used to open add owner modal
  openAddOwnerModal() {
    this.selectedOwner = "";
    this.signatoryModalEditable = this.showActions;
    this.addOwnerModal = true;
    this.submitSRData(SrActionType.DRAFT);
  }
  showShareMsg: boolean = false;
  // This method is used to handle owner submit event using owner
  onOwnerSubmit(owner: any) {
    this.showShareMsg = false;
    const existingIndex = this.ownerList.findIndex((o: any) => o.ownerId === owner.ownerId);
    if (this.ownerList.length > 0 && existingIndex !== -1) {
      this.ownerList[existingIndex] = owner;
    } else {
      owner["ownerId"] = this.ownerList.length + 1;
      owner["relationType"] = "Contact Of";
      owner["authorisedSignatory"] = "Y";
      owner["isNewSignatory"] = true;
      owner["action"] = "Add";
      owner["showRequiredFieldError"] = false;

      this.ownerList = [...this.ownerList, owner];
    }
    this.noSignatoryChangesMsg = false;
    this.clearSignatoryRequiredFieldErrors();

    this.updateDocumentsMandatory(this.ownerList);
  }
  // This method is used to owner view remove using owner
  ownerViewRemove(owner: any) {
    if (owner.type == 'update-action') {
      const existingIndex = this.ownerList.findIndex((o: any) => o.ownerId === owner?.data.ownerId);
      if (this.ownerList.length > 0 && existingIndex !== -1) {
        owner.data["isActionUpdated"] = true;
        if (owner.data?.action == "Add" || owner.data?.action == "Remove") {
          owner.data["authorisedSignatory"] = owner.data?.action == "Add" ? "Y" : "N";
          const date = new Date();
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
          const year = date.getFullYear();

          let endDate = `${month}/${day}/${year}`;
          owner.data["endDate"] = owner.data?.action == "Remove" ? endDate : "";
        }
        this.ownerList[existingIndex] = owner.data;
      }
      this.noSignatoryChangesMsg = false;
    } else {
      if (owner.type == 'edit') {
        this.selectedOwner = owner.data;
        this.signatoryModalEditable = this.showActions;
        this.addOwnerModal = true;
      } else if (owner.type == 'view') {
        this.selectedOwner = owner.data;
        this.signatoryModalEditable = false;
        this.addOwnerModal = true;
      } else {
        this.ownerList = this.ownerList.filter((o: any) => o.ownerId != owner.data.ownerId);
        this.ownerList.map((o: any) => o["isActionUpdated"] = true);
      }
    }
    this.updateDocumentsMandatory(this.ownerList);
    this.clearSignatoryRequiredFieldErrors();
  }
  totalSteps: number = 3;
  step: number = 1;
  isFromSumit: boolean = false;
  formSubmitLoader: boolean = false;
  private isSrSubmitInProgress: boolean = false;
  isSaved: boolean = false;
  successModal: boolean = false;
  showActions: boolean = true;
  loadingSrDeetail: boolean = false;
  currentSrStatus: string = '';

  // This method is used to calculate form progress
  get formProgress() {
    if (this.srFolder) {
      if (!this.checkRequiredDocuments()) {
        return 100;
      }
    }
    return Utils.calculateFormProgress(this.step, this.totalSteps)
  }
  // This method is used to save and close
  saveAndClose() {
    this.submitSRData(SrActionType.SAVE);
  }

  // This method is used to handle the next callback
  submit() {
    const skipSignatoryChangeValidation =
      this.currentSrStatus === SrStatus.AwaitingClarification;
    const hasSignatoryChanges = this.hasSignatoryChanges();
    const hasNoChangeSupportDocument = this.hasNoChangeSupportDocumentUploaded();

    if (!skipSignatoryChangeValidation && !hasSignatoryChanges && !hasNoChangeSupportDocument) {
      this.noSignatoryChangesMsg = true;
      return;
    }
    this.noSignatoryChangesMsg = false;
    this.submitSRData(SrActionType.SUBMIT);
  }


  noSignatoryChangesMsg: boolean = false;  
  errorMsg: string = "";
  technicalErrorMsg: boolean = false;
  // This method is used to submit sr data using action type
  submitSRData(actionType: string) {
    this.errorMsg = "";
    this.technicalErrorMsg = false;
    let isActionSubmit = actionType == SrActionType.SUBMIT;
    let isActionSave = actionType == SrActionType.SAVE;
    let isActionDraft = actionType == SrActionType.DRAFT;
    const defaultShowActions = this.showActions;
    const defaultSignatoryModalEditable = this.signatoryModalEditable;
    const restoreFormState = () => {
      this.showActions = defaultShowActions;
      this.signatoryModalEditable = defaultSignatoryModalEditable;
      this.formSubmitLoader = false;
    };
    if (this.isSrSubmitInProgress) {
      return;
    }
    if (isActionSubmit && this.markSignatoryRequiredFieldErrors(true)) {
      const target = document?.getElementById('signatory-list-section');
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.sharedService.toastMessage('ERROR', "FILL_SIGNATORY_DETAILS", 'error', false);
      return;
    }
    let srSubType = ServiceName.MEMBERSHIP_MANAGEMENT_SIGNATORIES;
    const skipSignatoryChangeValidation =
      this.currentSrStatus === SrStatus.AwaitingClarification;
    const hasSignatoryChanges = this.hasSignatoryChanges();
    const hasNoChangeSupportDocument = this.hasNoChangeSupportDocumentUploaded();
    // check if there is no signatory change and no supporting document upload for no-change scenario
    if (!skipSignatoryChangeValidation && !isActionDraft && !hasSignatoryChanges && !hasNoChangeSupportDocument) {
      this.noSignatoryChangesMsg = true;
      return;
    }
    this.noSignatoryChangesMsg = false;

    if (isActionSubmit && this.checkRequiredDocuments()) {
      this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
      return;
    }
    this.request.body.SiebelMessage.MessageId = Utils.generateUniqueId();
    this.request.body.DCMethod = isActionSubmit ? 'SUBMIT' : 'SAVEASDRAFT';

    const sr = this.request.body.SiebelMessage.ListOfDCMemSRIO["DC Mem SR"];
    sr["DC Channel"] = this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;
    sr['SR Type'] = ServiceName.MEMBERSHIP;
    sr['SR Sub Type'] = srSubType;

    sr["DC Member Name(Arabic)"] = this.memberDetail ? this.memberDetail["DC Name Arabic"] : "";
    sr["DC Member Name(English)"] = this.memberDetail ? this.memberDetail["DC Name English"] : "";
    sr["SR Number"] = this.srNumber ?? "";
    sr["Account Id"] = this.accountId;
    // sr["DC Firm Type"]= this.memberDetail ? this.memberDetail["Firm Type"] : ""
    let sginatoryObjects: any = [];
    this.ownerList?.map((owner: any) => {
      // Set isAuthorisedSignatory flag
      const isAuthorisedSignatory = owner.authorisedSignatory; //? 'Y' : 'N';
      let jobTitle = 'Authorised Signatory';
       let emiratesDob =(
        owner?.emiratesDob?.day && 
        owner?.emiratesDob?.month && 
        owner?.emiratesDob?.year && 
        !isNaN(Number(owner.emiratesDob.day)) && 
        !isNaN(Number(owner.emiratesDob.month)) && 
        !isNaN(Number(owner.emiratesDob.year))
      ) 
      ? `${owner.emiratesDob.month}/${owner.emiratesDob.day}/${owner.emiratesDob.year}` 
      : '';
      let passportExpiry =(
        owner?.passportExpiry?.day && 
        owner?.passportExpiry?.month && 
        owner?.passportExpiry?.year && 
        !isNaN(Number(owner.passportExpiry.day)) && 
        !isNaN(Number(owner.passportExpiry.month)) && 
        !isNaN(Number(owner.passportExpiry.year))
      ) 
      ? `${owner.passportExpiry.month}/${owner.passportExpiry.day}/${owner.passportExpiry.year}` 
      : '';

      let relationship = {
        "Account Membership Id": owner.accountMembershipId ? owner.accountMembershipId : "",
        "Relationship": owner.relationType ? owner.relationType : 'Contact Of',
        "Action Type": owner.action ? owner.action : "No Change",
        "DC Start Date": "", //not
        "DC End Date": owner.endDate,
        "DC Member Relationship": owner.relationType ? owner.relationType : 'Contact Of',
        "DC Main Phone": `${owner.countryCode}${owner.mobile}`,
        "Member DOB": emiratesDob,
        "DC Emirates ID Number": owner.emiratesId ? owner.emiratesId : "",
        "DC National ID": null,
        "DC Ownership Percent": owner.share ? owner.share : '',
        "DC Relationship Type": "Contact", //Organization
        "DC PP Exp Date": passportExpiry,
        "UAE Citizen": owner.isResident && (owner.isResident == FieldValue.YES || owner.isResident == FieldValue.YES_AR) ? "Yes" : 'No',
        "DC Contact Name(ARABIC)": owner.nameAr ?? '',
        "DC Contact Name(ENGLISH)": owner.nameEn ?? '',
        "DC Name(ENGLISH)": '',
        "DC Name(ARABIC)": '',
        "DC Cell Phone": `${owner.countryCode}${owner.mobile}`,
        "Membership Year": "",
        "DC DED Partner Passport Number": owner.passportNumber ?? '',
        "DC Contact Nationality": owner.nationality,
        "DC Email Address": owner.email,
        "DC DED PartnerNationalityCode": "",
        "DC Authorized Signatory": isAuthorisedSignatory,
        "DC Job Title": jobTitle,
      }
      sginatoryObjects.push(relationship);
    });
    if (sginatoryObjects && sginatoryObjects.length > 0) {
      (sr["ListOfDC Mem SR Relationship"] as ListOfDCMemSRRelationship)["DC Mem SR Relationship"] = sginatoryObjects;
    } else {
      if (sginatoryObjects && sginatoryObjects.length < 1) {
        sr["ListOfDC Mem SR Relationship"] = {}
      }
    }
    if (!isActionDraft) {
      this.showActions = false;
      this.signatoryModalEditable = false;
      this.formSubmitLoader = true;
    }
    this.isSrSubmitInProgress = true;
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.CREATE_UPDATE_SR,
      this.request
    ).subscribe({
      next: (response: any) => {
        if ((response['Error Code'] == "" || response['Error Code'] == "DC-VAL-ERR")
          && response["Error Message"] == null || response["Error Message"] == ""
          && response["SR Number"]) {
          this.isSaved = true;

          if (isActionSave || isActionDraft) {
            if (isActionDraft && this.srNumber == "") {
              this.srNumber = response["SR Number"];
              sessionStorage.setItem("srNumber", response["SR Number"]);
              this.openFolder();
            } else {
              this.srNumber = response["SR Number"];
              if (isActionSave) {
                this.successModal = true;
              }
            }
          } else {
            this.srNumber = response["SR Number"];
            let lang: any = this.sharedService.getCurrentLang();

            const { service, serviceAr } = Utils.getServiceLabels(srSubType, lang);
            let srDetailObj = {
              serviceSubTypeEn: service,
              serviceSubTypeAr: serviceAr,
              service: srSubType,
              IOName: SrIOName.MEMBERSHIP,
              srNumber: this.srNumber,
              totalSteps: this.totalSteps,
              step: this.step
            }
            this.sharedService.setSrResponse(srDetailObj);

            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            sessionStorage.removeItem("srNumber");
            this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.SUCCESS_PAGE + "/" + this.srNumber}`]);
          }
          restoreFormState();
          this.isSrSubmitInProgress = false;
        } else {
          restoreFormState();
          this.isSrSubmitInProgress = false;
          if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != "") {
            this.errorMsg = response['Error Message'];
          } else {
            this.technicalErrorMsg = true;
          }
        }
      },
      error: () => {
        this.isSaved = true;
        restoreFormState();
        this.technicalErrorMsg = true;
        this.isSrSubmitInProgress = false;
      }
    })
  }
  // This method is used to close success modal
  closeSuccessModal() {
    this.successModal = false;
    sessionStorage.removeItem("srNumber");
    this.router.navigate([RoutesPath.DASHBOARD]);
  }

  // This method is used to handel file event using document and document field
  handelFileEvent(document: any, documentField: any) {
    this.noSignatoryChangesMsg = false;
  }
  // This method is used to close pending sr modal
  closependingSrModal() {
    this.pendingSrNumber = "";
    this.router.navigate([RoutesPath.DASHBOARD]);
  }
  // This method is used to get member documents
  getMemberDocuments() {
    this.sharedService
      .getDocuments(this.srNumber, DocumentServiceType.MEMBERSHIP_WALLET, false, {
        memNumber: this.userCSN,
      })
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            const memberDocuments = response.data ?? response;
            if (
              !memberDocuments?.documents?.length ||
              !this.srFolder?.allowedDocumentTypes?.length
            ) {
              return;
            }
            this.memberDocumentFolderId = memberDocuments?.folderId ?? null;
            const cleared = MembershipSharedService.applyPendingMoaClear(
              memberDocuments.documents,
              this.shouldClearMoaFromMemberDocs
            );
            this.memberDocuments = cleared.memberDocuments;
            this.shouldClearMoaFromMemberDocs = cleared.shouldClearMoaFromMemberDocs;

            // Build Set of allowed doc type names
            const allowedTypes = new Set(
              this.srFolder.allowedDocumentTypes.map((d: any) => d.nameEn)
            );
            // Filter matching member docs
            const matchedMemberDocs = this.memberDocuments.filter((doc: any) =>
              allowedTypes.has(doc.documentType)
            );
            // Avoid duplicates (based on documentType + notes)
            const existingKeys = new Set(
              this.srFolder?.documents?.map(
                (d: any) => `${d.documentType}-${d.notes || ''}`
              )
            );
            let memberFolderId = this.memberDocumentFolderId;
            // Filter only unique documents
            const uniqueMemberDocs = matchedMemberDocs
              .filter(
                (doc: any) =>
                  !existingKeys.has(`${doc.documentType}-${doc.notes || ''}`)
              )
              // Add memberFolderId to each document
              .map((doc: any) => ({
                ...doc,
                memberFolderId: memberFolderId ?? null,
              }));
            if (uniqueMemberDocs.length > 0) {
              // Merge safely into srFolder and notify child components
              const updatedDocuments = [
                ...(this.srFolder.documents ?? []),
                ...uniqueMemberDocs,
              ];
              this.srFolder = {
                ...(this.srFolder ?? {}),
                documents: updatedDocuments,
              };
            }
          }
        },
        error: (err) => {
        },
      });
  }
  ngOnDestroy(): void {
    sessionStorage.removeItem("srNumber");
  }

  updateDocumentsMandatory(ownersList: any[]) {
    // STEP 1: Derive vSignatoryAdded and vSignatoryRemoved from ownersList 
    const vSignatoryAdded = ownersList.some(o => o.action?.toLowerCase() === 'add') ? 'Y' : 'N';
    const vSignatoryRemoved = ownersList.some(o => o.action?.toLowerCase() === 'remove') ? 'Y' : 'N';
    const count = ownersList ? ownersList.length : 0;
    const isFreezone = this.licenseCategory === 'Freezone';

    // STEP 2: Clone allowedDocumentTypes to avoid mutating the original 
    let updatedDocs = this.mainFromSectionDocs || [];
    // Reset all mandatory flags
    updatedDocs.forEach(d => (d.mandatory = false));
    // STEP 3: Apply logic from the Siebel script  count < 3 &&
    if (vSignatoryAdded === 'Y' && vSignatoryRemoved === 'N') {
      // Case 1: Added only
      if (isFreezone) {
        this.setMandatory(updatedDocs, [
          'Letter_From_Authorized_Person'
        ]);
      } else {
        this.setMandatory(updatedDocs, [
          'Power_of_Attorney'
        ]);
      }
    } else if (vSignatoryRemoved === 'Y' && vSignatoryAdded === 'N') {
      this.clearMoaForOwnerChanges()
      // Case 2: Removed only
      this.setMandatory(updatedDocs, [
        'Memorandum_of_Association',
        'Letter_From_Authorized_Person'
      ]);
    } else if (vSignatoryRemoved === 'Y' && vSignatoryAdded === 'Y') {
      this.clearMoaForOwnerChanges()
      // Case 3: Added and Removed both
      if (isFreezone) {
        this.setMandatory(updatedDocs, [
          'Memorandum_of_Association',
          'Letter_From_Authorized_Person'
        ]);
      } else {
        this.setMandatory(updatedDocs, [
          'Memorandum_of_Association',
          'Letter_From_Authorized_Person',
          'Power_of_Attorney'
        ]);
      }
    }
    // STEP 4: Update mainFromSectionDocs (filter non-person docs if required) 
    this.mainFromSectionDocs = updatedDocs.filter((d: any) => !d.forUISection);
  }

  private setMandatory(docs: any[], names: string[]) {
    docs.forEach(d => {
      if (names.includes(d.nameEn)) {
        d.mandatory = true;
      }
    });
  }

  private clearMoaForOwnerChanges(): void {
    const result = MembershipSharedService.clearMoaAfterOwnerChange(
      this.srFolder,
      this.memberDocuments
    );
    this.srFolder = result.srFolder as FolderResponse;
    this.memberDocuments = result.memberDocuments;
    this.shouldClearMoaFromMemberDocs = result.shouldClearMoaFromMemberDocs;
  }

  countryLovList: any = [];
  getCountryLOV() {
    this.lookupService.post(LookupKey.LOOKUP_URL, {
      "ProcessName": "DC Get List Of Values WF",
      "Type": LookupKey.COUNTRY,
      "LanguageCode": this.lang == 'ar' ? 'ARA' : 'ENU',
      "ParentValue": "",
      "Sub Type": ""
    })
      .subscribe({
        next: (response: any) => {
          if (response['Error Message'] == null && response.SiebelMessage?.['List Of Values']) {
            this.countryLovList = Utils.checkIsArray(response.SiebelMessage['List Of Values']);
             this.checkForPendingSr();
          }
        }
      })

  }

   private hasSignatoryChanges(): boolean {
    return this.ownerList.some(
      owner =>
        // owner.isActionUpdated === true ||
        owner.isNewSignatory === true ||
        owner.action === 'Add' ||
        owner.action === 'Remove'
    );
  }

  private hasNoChangeSupportDocumentUploaded(): boolean {
    const docs = Utils.checkIsArray(this.srFolder?.documents);
    if (!docs.length) {
      return false;
    }
    return docs.some((doc: any) => {
      const type = String(doc?.documentType || doc?.nameEn || '').trim();
      if (!this.noChangeSupportDocumentTypes.has(type)) {
        return false;
      }
      // Exclude member-wallet merged documents; require upload in current SR folder.
      return !doc?.memberFolderId;
    });
  }

  private clearSignatoryRequiredFieldErrors(): void {
    this.ownerList = (this.ownerList || []).map((owner: any) => ({
      ...owner,
      showRequiredFieldError: false
    }));
  }

  private markSignatoryRequiredFieldErrors(showError: boolean): boolean {
    let hasMissing = false;
    this.ownerList = (this.ownerList || []).map((owner: any) => {
      const missing = this.hasMissingSignatoryRequiredFields(owner);
      if (missing) {
        hasMissing = true;
      }
      return {
        ...owner,
        showRequiredFieldError: showError && missing
      };
    });
    return hasMissing;
  }

  private hasMissingSignatoryRequiredFields(owner: any): boolean {
    if (!owner) {
      return true;
    }

    const hasValue = (value: any): boolean => `${value ?? ''}`.trim() !== '';
    const hasDate = (dateObj: any): boolean =>
      !!dateObj && hasValue(dateObj.day) && hasValue(dateObj.month) && hasValue(dateObj.year);

    const commonRequired =
      hasValue(owner.nameEn) &&
      hasValue(owner.nameAr) &&
      hasValue(owner.nationality) &&
      hasValue(owner.email) &&
      hasValue(owner.mobile) &&
      hasValue(owner.countryCode);

    if (!commonRequired) {
      return true;
    }

    const isUaeResident = (owner.isResident ?? 'No') === 'Yes';
    if (isUaeResident) {
      return !(hasValue(owner.emiratesId) && hasDate(owner.emiratesDob));
    }

    return !(hasValue(owner.passportNumber) && hasDate(owner.passportExpiry));
  }
  
  private getMatchedCountryValue(countryName: string): string | null {
    const normalizedCountryName = (countryName || '').trim().toLowerCase();
    if (!normalizedCountryName || !Array.isArray(this.countryLovList)) {
      return null;
    }
    const matchedCountry = this.countryLovList.find((country: any) => {
      const normalizedName = (country?.Name || '').trim().toLowerCase();
      const normalizedValue = (country?.Value || '').trim().toLowerCase();

      return normalizedName === normalizedCountryName || normalizedValue === normalizedCountryName;
    });

    return matchedCountry?.Value || null;
  }

}
